import { createRouter, createWebHashHistory } from 'vue-router';
import { capturePageLeave, capturePageView } from '@/analytics/posthog';
import Releases from '@/tabs/Releases.vue';
import VueRouteNotFound from '@/views/VueRouteNotFound.vue';

const EmptyAngularRoute = { template: '<div></div>' };

const routes = [
    {
        path: '/v/System/Releases',
        name: 'SystemReleases',
        component: Releases,
    },
    {
        path: '/v/:pathMatch(.*)*',
        name: 'VueRouteNotFound',
        component: VueRouteNotFound,
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'AngularRoute',
        component: EmptyAngularRoute,
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

router.afterEach((to, from) => {
    if (from.fullPath && from.fullPath !== to.fullPath) {
        capturePageLeave(from.fullPath);
    }

    capturePageView(to.fullPath);
});

export default router;
